// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_lw-0";